// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__uKZDW","modal":"Modal_modal__EqaZW","closeIcon":"Modal_closeIcon__0L56G","footer":"Modal_footer__qp2Zw"};